export default __webpack_public_path__ + "static/media/scenarios_card_img_2.194d31d5.svg";